import Form from 'next/form';

import { Input } from './ui/input';
import { Label } from './ui/label';
import { isEn } from '@/lib/utils';

export function AuthForm({
  action,
  children,
  defaultEmail = '',
  defaultId = '',
  pageName = '',
}: {
  action: NonNullable<
    string | ((formData: FormData) => void | Promise<void>) | undefined
  >;
  children: React.ReactNode;
  defaultEmail?: string;
  defaultId?: string;
  pageName?: string;
}) {
  return (
    <Form action={action} className="flex flex-col gap-4 px-4 sm:px-16">
      <div className="flex flex-col gap-2">
        <Label
          htmlFor="email"
          className="text-zinc-600 font-normal dark:text-zinc-400"
        >
          {isEn ? 'Email Address' : '邮箱'}
        </Label>

        <Input
          id="email"
          name="email"
          className="bg-muted text-md md:text-sm"
          type="email"
          placeholder="请输入邮箱"
          autoComplete="email"
          required
          autoFocus
          defaultValue={defaultEmail}
        />
      </div>

      <div className="flex flex-col gap-2">
        <Label
          htmlFor="password"
          className="text-zinc-600 font-normal dark:text-zinc-400"
        >
          {isEn ? 'Password' : '密码'}
        </Label>

        <Input
          id="password"
          name="password"
          className="bg-muted text-md md:text-sm"
          type="password"
          required
        />
      </div>

      {pageName === 'register' &&  <div className="flex flex-col gap-2">
        <Label
          htmlFor="invitationCode"
          className="text-zinc-600 font-normal dark:text-zinc-400"
        >
          {isEn ? 'Invite Code' : '邀请码'}
        </Label>

        <Input
          id="invitationCode"
          name="invitationCode"
          className="bg-muted text-md md:text-sm"
          type="text"
          minLength={4}
          required
        />
      </div>}

      {/* <div className="text-balance text-center text-xs text-muted-foreground [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-primary">
        By clicking continue, you agree to our <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.
      </div> */}

      {defaultId && <div className="flex flex-col gap-2 opacity-10 h-1">
        <Label
          htmlFor="deviceId"
          className="text-zinc-600 font-normal dark:text-zinc-400 opacity-10 h-1"
        >
          {isEn ? 'Device Id' : '环境令牌'}
        </Label>

        <Input
          id="deviceId"
          name="deviceId"
          className="bg-muted text-md md:text-sm opacity-10 h-1"
          type="text"
          placeholder=""
          autoComplete=""
          required
          autoFocus
          defaultValue={defaultId}
        />
      </div>}
      {children}
    </Form>
  );
}
